module.exports = __webpack_public_path__ + "img/Cancer.1bd5a0f9.png";